import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRoutes from 'routes';
import './index.css';
import { DeviceProvider } from 'components/DeviceContext.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DeviceProvider>
    <AppRoutes/>
    </DeviceProvider>
  </React.StrictMode>
);


